import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CONTACTS_CRUD_ACTION_CREATORS } from '../actions/contacts_actions';

export const contactsRestCrudThunksForBuyer = new RestCrudThunks(
	'',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'common_contacts'
);
export const contactsRestCrudThunksForSupplier = new RestCrudThunks(
	'',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'common_contacts'
);

export const getContactsRestCrudThunksWithInternalTechs = (userType: string) =>
	new RestCrudThunks(
		'/buyer_internal_team_users_list',
		'contact',
		'contact',
		'contacts',
		CONTACTS_CRUD_ACTION_CREATORS,
		null,
		userType,
		false,
		'common_contacts'
	);

export const contactsRestCrudThunksForSupplierForThirdPartySuppliers = new RestCrudThunks(
	'/supplier_users_list',
	'contact',
	'contact',
	'contacts',
	CONTACTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'common_contacts'
);

// Adaptor that maps user.id to email field to ensure unique keys in the contacts reducer
const contactsEmailAdaptor = (users) => users.map((user) => ({ ...user, email: user.id }));

// Wrapped read functions that apply the email adaptor
export const getContactsWithInternalTechs = (userType: string) => {
	const thunks = getContactsRestCrudThunksWithInternalTechs(userType);
	return {
		read: (
			params,
			targetCollectionName = null,
			pagination = null,
			sorting = null,
			filters = null,
			addToTargetCollection = false
		) =>
			thunks.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection,
				contactsEmailAdaptor
			),
	};
};

export const getContactsForThirdPartySuppliers = {
	read: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) =>
		contactsRestCrudThunksForSupplierForThirdPartySuppliers.read(
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection,
			contactsEmailAdaptor
		),
};
